import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <g id="B" transform="translate(22.00000, 24.000000)">
          <path
            d="M 35.722 36.729 L 28.514 36.729 Q 27.772 34.556 26.977 32.436 Q 26.182 30.316 25.44 28.09 L 9.964 28.09 Q 9.222 30.316 8.454 32.463 Q 7.685 34.609 6.943 36.729 L 0 36.729 Q 2.067 30.846 3.922 25.864 Q 5.777 20.882 7.553 16.43 Q 9.328 11.978 11.077 7.95 Q 12.826 3.922 14.681 0 L 20.988 0 Q 22.843 3.922 24.592 7.95 A 295.019 295.019 0 0 1 27.23 14.231 A 336.05 336.05 0 0 1 28.117 16.43 Q 29.892 20.882 31.774 25.864 Q 33.655 30.846 35.722 36.729 Z M 11.66 22.684 L 23.744 22.684 Q 22.048 17.967 20.458 13.886 Q 18.906 9.904 17.759 7.233 A 112.711 112.711 0 0 0 17.702 7.102 A 138.21 138.21 0 0 0 16.739 9.38 Q 15.897 11.422 14.92 13.939 A 333.726 333.726 0 0 0 13.323 18.139 A 416.909 416.909 0 0 0 11.66 22.684 Z"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconLogo;
